import React, { createContext, useState } from 'react';
import api from '@services/api';
import productParams from '../create/templates/product_params';
import productEditParams from '../edit/templates/product_params';

export const ProductContext = createContext();

export function CreateProductProvider({ children }) {
  const [params, setParams] = useState(productParams);
  const [value, setValue] = useState('recurrent');
  const [openDiscardModal, setOpenDiscardModal] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [priceRangeErrors, setPriceRangeErrors] = useState([]);

  const handleTypeChange = (e) => {
    setValue(e.target.value);
  };

  const setEditProduct = async (id) => {
    const response = await api.get(`/admin/products/${id}`);
    const { product } = response.data;
    setParams(productEditParams(product));
    setFetched(true);
  };

  const handleChange = (values) => {
    const pricingRanges = values.pricing_schema_attributes.pricing_ranges_attributes;

    setParams({
      ...values,
      schema_type: values.schema_type,
      pricing_schema_attributes: {
        ...values.pricing_schema_attributes,
        schema_type: values.schema_type,
        pricing_ranges_attributes: pricingRanges,
      },
    });
  };

  return (
    <ProductContext.Provider value={{
      params,
      handleChange,
      value,
      handleTypeChange,
      openDiscardModal,
      setOpenDiscardModal,
      fetched,
      setEditProduct,
      setPriceRangeErrors,
      priceRangeErrors,
    }}
    >
      {children}
    </ProductContext.Provider>
  );
}
